import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Editor</Typography>
      The editor is a where you will fine-tune your pass templates. It shows you andaccurate representation
      what a sample pass will look like on both Apple and Google devices. For Apple you see a typical lock screen
      notification, the front and back of the pass. For Google, you see a list item, front and back of the pass. 

      <Typography variant='h5' className='pt-10 pb-5'>Settings</Typography>
      This is where you will want to take a look at those settings... The icon next to the help one.
      There are two that are relevant here which you'll probably want to toggle on/off from time to time as you work:

      <ul>
        <li><b>Highlight Editable Items</b> : This toggles the pulsating boxes that highlight where all of the editable content it. 
        It is very helpful to see where empty editable fields are, but can be distracting when you are checking the overall look
        of your template. </li>
        <li><b>Show auto-generated content</b> : Some content cannot be edited an is auto-generated by Apple and Google. It 
        can be good to see how your content fits around that, but canalos be distracting. Toggle it on/off as you see fit.</li>
      </ul>

      <Typography variant='h5' className='pt-10 pb-5'>Quick tutorial</Typography>
      <p>
        The editor is intuitive to use and you should soon find yourself fluent in all its nuances. You can find a complete
        reference on our <a href="https://www.smartix.uk/studio/template-editor/" target='_blank'>website</a>, so we will only give you the important points here.
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Colours, Meta Data and Apps</Typography>
      <p>On the right hand side you'll see a panel showing with three options:</p>
            
      <Typography variant='h6' className='pl-10 pt-2'>Colours</Typography>

      <p className='pl-10'>Use this to choose the colours for your passes. Note that Apple allows you 
        to choose background and text colours, whereas Google only allows you to choose a background colour then it chooses either balck or white for your text.
        Either choose with the picker, or paste in a HEX value in the inout box.
      </p>

      <p className='pl-10'>Also note that Apple uses an unexpected rule to override the colour of the logo text (which is usually taken from the Text Colour value)
        and instead takes the colour from the Label Colour value. It does this based on the Background colour value, but in a way that we cannot determine with 100% precision. 
        There is an "ambiguous zone" where we really can't tell. Outside of this zone you can be confident in our prediction. If you are in the ambiguous zone then either tweak your
        colour (just a tiny change is needed) or make a test ticket and viewe it on an Apple device. Be aware, however, that the preview you see on a Mac always useses foreground colour
        even if the device will choose label colour, so always check on a real device. Also, event tickets with a background image always use the label colour, regardless of the backgroudn colour / image colours.
      </p>

      <Typography variant='h6' className='pl-10 pt-5'>Meta Data</Typography>

      <p className='pl-10'>Here you can set a range of options:
        <ul>
          <li><b>Retention period</b> : How long a pass should be retained after it expires before it is automatically deleted</li>
          <li><b>Apple - allow sharing</b> : Whether the sharing icon should be displayed on Apple devices. Note: This does NOT
          prevent the pass being shared by other means.</li>
          <li><b>Google - allow screenshots</b> : Prevent the simplest sharing by screenshotting a pass.</li>
          <li><b>Google - sharing options</b> : Google allows you to place restrictions on devices a pass can be installed on. 
          There are pros and cons, so refer to our <a href="http://www.smartix.uk/studio/template-editor/" target="_blank">website</a> for more information. 
          NOTE: You cannot change to a single user options once you have issued a pass (including a test one). Google does not permit this.</li>
        </ul>
      </p>

      <Typography variant='h6' className='pl-10 pt-5'>Apps</Typography>
      <p className='pl-10'>If you have a native Apple or Google app that you would like displayed within your pass, then use this form to locate it in the
        App stores.</p>


      <Typography variant='h5' className='pt-10 pb-5'>Text fields</Typography>
      <p>Click in an editable region to open the field editor side panel.</p>

      <p>Layout can be a little tricky...if you have a single text field, then it will always be placed to the left hand side of the pass. If you use centre or right align option 
        (Apple only)then the heading and body text stay on the left, but are aligned relative to each other.</p>

      <p>If you want to place a single text item on the right, then you have to create TWO text items and just leave the first one blank (no header, no body). Fill in the second one. 
        Then you field will be placed on the right hand side.
      </p>

      <p>If you want to place a single text item in the centre, then you have to create THREE text items and just leave the first one and last one blank (no header, no body). Fill in the second one. 
        Then you field will be placed in the centre of the pass.
      </p>

    </div>
  )
}

export default HelpText